module.exports = __webpack_public_path__ + "media/Lighttwo.50b44678.wav";